import React, { useRef, useEffect, useState } from "react";
import { FaCalendarAlt, FaCog } from "react-icons/fa";
import { HiMiniUserGroup } from "react-icons/hi2";
import { CiSaveDown2 } from "react-icons/ci";
import { useNavigate, useLocation } from "react-router-dom";
import Images from "../../constant/Images";
import { clearUserData, userName, userRole } from "../../utils/storage";
import { MdEventAvailable, MdOutlineAdminPanelSettings } from "react-icons/md";
import { FaTasks } from "react-icons/fa";

import { BiSolidUser } from "react-icons/bi";
const Header = () => {
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef(null);

  const allHeaderMenu = [
    { label: "Schedule", icon: <FaCalendarAlt />, path: "/home" },
    { label: "Users", icon: <HiMiniUserGroup />, path: "/users" },
    {
      label: "Meeting Request",
      icon: <CiSaveDown2 />,
      path: "/meeting-request",
    },
    {
      label: "Chairman Meeting Request",
      icon: <MdOutlineAdminPanelSettings />,
      path: "/chairman-meeting-request",
      superAdminOnly: true,
    },
    {
      label: "Event",
      icon: <MdEventAvailable />,
      path: "/events",
    },
    {
      label: "Task",
      icon: <FaTasks />,
      path: "/tasks",
      superAdminOnly: true,
    },
    {
      label: "Setup",
      icon: <FaCog />,
      path: "/setup",
    }
  ];

  const headerMenu = allHeaderMenu.filter(
    (item) => !item.superAdminOnly || userRole === "SUPER_ADMIN"
  );

  const currentPath = location.pathname;

  const getActiveMenu = () => {
    if (currentPath.startsWith("/home")) return "Schedule";
    if (currentPath.startsWith("/users")) return "Users";
    if (currentPath.startsWith("/meeting-request")) return "Meeting Request";
    if (currentPath.startsWith("/chairman-meeting-request")) return "Chairman Meeting Request";
    if (currentPath.startsWith("/events")) return "Event";
    if (currentPath.startsWith("/tasks")) return "Task";
    if (currentPath.startsWith("/setup")) return "Setup";
    return "";
  };

  const activeMenu = getActiveMenu();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsProfileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="flex sticky top-0 z-30 justify-between p-4 items-center bg-white">
      {/* Logo / Title */}
      <div className="font-semibold text-primary">
        <img src={Images.clientLogo} alt="Logo" className="w-16" />
      </div>

      {/* Header Menu */}
      <div className="flex items-center gap-10">
        {headerMenu.map((item, index) => (
          <div
            key={index}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center gap-1 text-sm text-gray-600 ${
              activeMenu === item.label ? "text-primary" : ""
            } hover:text-primary cursor-pointer`}
          >
            <div className="text-[22px]">{item.icon}</div>
            <div>{item.label}</div>
          </div>
        ))}
      </div>

      {/* Profile + Dropdown */}
      <div className="relative" ref={dropdownRef}>
        <div
          className="flex items-center gap-3 rounded-full px-3 py-2 border border-slate-200 text-sm text-gray-700 cursor-pointer"
          onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
        >
          <div className="flex flex-col gap-1">
            <div className="font-medium">Hi, {userName}</div>
            <div>NFBD</div>
          </div>
          <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-green-600 font-bold text-xl">
              {userName.charAt(0) || 'U'}
            </div>
        </div>

        {isProfileMenuOpen && (
          <div className="absolute right-0 mt-5 w-48 bg-white rounded-lg shadow-lg py-1 z-50">
            <div className="px-4 py-2 border-b border-gray-100">
              <p className="text-sm font-medium text-gray-900">{userName}</p>
              <p className="text-xs text-gray-500">{userRole}</p>
            </div>
            <button
              className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              onClick={() => {
                navigate("/myprofile");
              }}
            >
              Profile
            </button>
            <button
              className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              onClick={() => {
                setIsProfileMenuOpen(false);
                navigate("/");

                localStorage.removeItem("userDetails");
                window.location.reload();
              }}
            >
              Sign Out
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
